const defaultOptions = {
    headerHeight: 38,
    rowHeight: 62,
    rtl: false,
    isDefaultSortedDesc: false,
    enableValueCache: false,
    enableRowDragging: false,
    columnResizingShift: false,
    enableCheckboxSelection: false,
    enableColumnDragging: false,
    enableRowClickSelection: false,
    enableRowClickKeyboardNavigation: true,
    disableSortRemove: false,
    disableRowFiltering: true,
    disableSortBy: false,
    disableResizing: false,
    panelWidth: 0,
    initialState: {},
};

export { defaultOptions as default };
//# sourceMappingURL=defaultOptions.js.map
